import { format } from "date-fns";
import { sl } from "date-fns/locale";

export function formatDate(date) {
  if (!date) return "";
  return format(new Date(date), "d.M.yyyy");
}

export function formatDateWithTime(date, showSeconds, showDay) {
  if (!date) return "";
  return format(new Date(date), `${showDay ? "eeee, " : ""}d.M.yyyy • HH:mm${showSeconds ? ":ss" : ""}`, { locale: sl });
}

export default {
  install: (app) => {
    app.config.globalProperties.$formatDate = formatDate;
    app.config.globalProperties.$formatDateWithTime = formatDateWithTime;
  },
};
